import {BaseRequestHandler} from "../requestHandler/BaseRequestHandler";
import {IItemSearchResponse} from "./interface/Item.interface";
import {IQueryData, ItemSearchQuery} from "./ItemSearchQuery";
import timer from "../logger/timer";
import {getRequestConfigurationWithToken} from "../requestHandler/getRequestConfigWithToken";

export class ItemFactory {
  @timer("API", "Items")
  public static async getItems(shopId: number, data: IQueryData): Promise<IItemSearchResponse> {
    const query = new ItemSearchQuery();
    query.addItemIds(data.itemIds);
    query.setLimit(data.limit);
    query.setOffset(data.offset);
    query.setCurrencyCode(data.currencyCode);
    query.setPromotionId(data.promotionId);
    query.setCategoryId(data.categoryId);
    // As stated by Konstantin Roemer but not stated in api docu
    // customer prices are shown depending on respective get param
    query.setCustomerId(data.customerId);
    // same here
    query.setCustomerGroupId(data.customerGroupId);
    query.setOtherFields(data);

    const queryString = query.getQueryString();
    const configuration = await getRequestConfigurationWithToken();

    return BaseRequestHandler.performRequest<IItemSearchResponse>(
      "GET",
      `shop/${shopId}/items?${queryString}`,
      configuration,
    );
  }
}
